import React, { useState } from 'react';
import SimpleDialog, { SimpleDialogProps } from '../SimpleDialog/SimpleDialog';
import { AppState } from '../../../store/state';
import { AppDispatch } from '../../../store/store';
import { connect } from 'react-redux';
import { selectCurrentUser } from '../../../store/selectors';
import { useTranslation } from 'react-i18next';
import UTCTooltip from '../../UTCTooltip/UTCTooltip';
import DateTimePickerWithOffset from '../../DateTimePickerWithOffset/DateTimePickerWithOffset';
import { getUserOffset } from '../../../helpers/timezone';

interface Props extends Omit<SimpleDialogProps, 'handleOk'> {
  end_date: string;
  handleOk: (date: string) => void;
  timezone: string | null;
  dateFormat: string | null;
}

const PhaseEndingDialog: React.FC<Props> = ({ end_date, handleOk, timezone, dateFormat, ...rest }) => {
  const { t, i18n } = useTranslation();
  const [endDate, setEndDate] = useState<string>(end_date);

  const utcOffset = getUserOffset(timezone);

  const title = (
    <div className="flex justify-between items-center">
      <span>{t('Edit ending')}</span>
      <UTCTooltip utcOffset={utcOffset} />
    </div>
  );

  return (
    <SimpleDialog {...rest} title={title} handleOk={() => handleOk(endDate)}>
      <DateTimePickerWithOffset
        required
        utcOffset={utcOffset}
        format={dateFormat ?? undefined}
        value={endDate ? new Date(endDate) : undefined}
        onChange={(date) => setEndDate(date.toISOString())}
        width="19rem"
        display="vertical"
        label={t('Date')}
      />
    </SimpleDialog>
  );
};

const mapStateToProps = (state: AppState) => ({
  timezone: selectCurrentUser(state).person.timezone,
  dateFormat: selectCurrentUser(state).person.date_format,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PhaseEndingDialog);
